import {
  createContext, useReducer
} from 'react';

export const types = {
  SET_TEST_RESULT: 'setTestResult',
  SET_TEST_RESULT_META: 'setTestResultMeta',
  TEST_RESULTS: 'testResults',
  TEST_RESULTS_META: 'testResultsMeta',
  NOTIFICATION_COUNT: 'notificationsCount',
  SET_NOTIFICATION_COUNT: 'setNotificationCount',
};
export const Context = createContext([{}, () => { }]);
const reducer = (state, action) => {
  switch (action.type) {
  case types.SET_TEST_RESULT: {
    return {
      ...state,
      [types.TEST_RESULTS]: {
        ...state[types.TEST_RESULTS],
        [action.payload.name]: action.payload.result,
      },
    };
  }
  case types.SET_TEST_RESULT_META: {
    return {
      ...state,
      [types.TEST_RESULTS_META]: {
        ...state[types.TEST_RESULTS_META],
        [action.payload.name]: action.payload.meta,
      },
    };
  }
  case types.SET_NOTIFICATION_COUNT: {
    return {
      ...state,
      [types.NOTIFICATION_COUNT]: action.payload,
    };
  }
  default:
    return state;
  }
};

export default function Provider({ children, initialState }) {
  const [state, dispatch] = useReducer(reducer, {
    [types.TEST_RESULTS]: {},
    [types.TEST_RESULTS_META]: {},
    [types.NOTIFICATION_COUNT]: 0,
    ...initialState,
  });

  return <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>;
}
